export default "__VITE_ASSET__CMaiXz4u__"